import * as SQLite from 'expo-sqlite';
import { DB_NAME, DB_VERSION } from './config';
import type { SQLiteDatabase } from 'expo-sqlite';

/**
 * Promesa singleton de la DB.
 * Nunca uses openDatabaseAsync() directamente en la app.
 */
let dbPromise: Promise<SQLiteDatabase> | null = null;

async function migrateIfNeeded(db: SQLiteDatabase) {
  // Leemos la versión actual
  const row = await db.getFirstAsync<{ user_version: number }>(
    'PRAGMA user_version'
  );
  const currentVersion = row?.user_version ?? 0;

  if (currentVersion >= DB_VERSION) return;

  // Ejemplo de migraciones simples
  await db.withExclusiveTransactionAsync(async (tx) => {
    switch (currentVersion) {
      case 0:
        await tx.execAsync(`
          CREATE TABLE IF NOT EXISTS users (
            id INTEGER PRIMARY KEY AUTOINCREMENT,
            name TEXT NOT NULL,
            email TEXT UNIQUE
          );

          PRAGMA user_version = ${DB_VERSION};
        `);
        break;
      // case 1: ... otras migraciones
      default:
        break;
    }
  });
}

/**
 * Devuelve siempre la misma instancia de SQLiteDatabase.
 */
export function getRawDatabase(): Promise<SQLiteDatabase> {
  if (!dbPromise) {
    dbPromise = (async () => {
      console.log('🔧 [DB] Inicializando base de datos...')
      const db = await SQLite.openDatabaseAsync(DB_NAME);

      // ✅ PRAGMAs recomendables para evitar locks
      try {
        // WAL mode: permite lecturas concurrentes durante escrituras
        await db.execAsync('PRAGMA journal_mode = WAL;');
        console.log('✅ [DB] WAL mode activado')
        
        // Foreign keys habilitadas
        await db.execAsync('PRAGMA foreign_keys = ON;');
        
        // Busy timeout: espera hasta 10 segundos antes de reportar "database is locked"
        await db.execAsync('PRAGMA busy_timeout = 10000;');
        console.log('✅ [DB] Busy timeout configurado a 10 segundos')
        
        // Cache size: incrementar para mejor performance
        await db.execAsync('PRAGMA cache_size = -2000;'); // 2MB
        
        // Temp store en memoria para transacciones más rápidas
        await db.execAsync('PRAGMA temp_store = MEMORY;');
        
        console.log('✅ [DB] Base de datos configurada correctamente')
      } catch (error) {
        console.error('❌ [DB] Error configurando PRAGMAs:', error)
      }

    //   await migrateIfNeeded(db); // Desactivar migraciones por ahora

      return db;
    })();
  }
  return dbPromise;
}
